import { cn } from '@/lib/ui/style-helpers'

export type AgDataTableWrapperProps = {
  className?: string
  children: React.ReactNode
}

export const AgDataTableWrapper = ({ className, children }: AgDataTableWrapperProps) => {
  return (
    <div className={cn('w-full transition-height duration-220 ease-snap', className)}>
      {children}
    </div>
  )
}
